import 'bootstrap/dist/css/bootstrap.css';

import ReactDOM from "react-dom/client";
import "react-loading-skeleton/dist/skeleton.css";
import "react-quill/dist/quill.snow.css";
import { RouterProvider } from "react-router-dom";
import { appRouter } from "./appRouter";

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

root.render(<RouterProvider router={appRouter} />);
